/*
  mk-color-sync.js — 8.10.2026 (Model Kids), v3
  Dvosmerna veza kružići boja ↔ slike na stranici proizvoda.
    1) Klik na kružić boje odmah prikazuje sliku te boje, i kad veličina još nije izabrana
       (app.js menja sliku tek kad su izabrane SVE opcije).
    2) Klik na sličicu, klik na veliku sliku ili prevlačenje galerije označava boju kojoj slika pripada.
    3) Slika koja NIJE vezana ni za jednu boju (detalj, materijal) poništava izbor boje — boja je označena
       samo kad kupac klikne na nju ili na sliku te boje. Izuzetak: proizvod sa jednom jedinom bojom
       (ona ostaje označena; unapred se označava od 6.9.2026 da ne bi iskakala greška "morate odabrati boju").
    4) (v3) Slika boje koja je SKROZ RASPRODATA (kružić ugašen / disabled) takođe poništava izbor boje.
  Ne menja app.js. Oslanja se na: radio inpute iz sections/product.liquid, data-id (ID varijanti) na
  sličicama iz snippets/productImages.liquid i JSON [data-product-json] / [data-product-options].
*/
(function () {
  'use strict';

  var sec = document.querySelector('[data-product-block]');
  if (!sec) return;
  var varEl = sec.querySelector('[data-product-json]');
  var optEl = sec.querySelector('[data-product-options]');
  var gallery = sec.querySelector('.c-images');
  if (!varEl || !optEl || !gallery) return;

  var variants, options;
  try {
    variants = JSON.parse(varEl.textContent);
    options = JSON.parse(optEl.textContent);
  } catch (e) { return; }
  if (!Array.isArray(variants) || !Array.isArray(options)) return;

  var colorIdx = -1;
  for (var i = 0; i < options.length; i++) {
    var n = String(options[i]).toLowerCase();
    if (n.indexOf('color') > -1 || n.indexOf('boj') > -1) { colorIdx = i; break; }
  }
  if (colorIdx < 0) return;

  var colorFs = sec.querySelector('fieldset[data-option-index="' + colorIdx + '"]');
  if (!colorFs) return;
  var fieldsets = sec.querySelectorAll('fieldset[data-option-index]');

  var byId = {};
  variants.forEach(function (v) { byId[String(v.id)] = v; });

  function thumbs() { return gallery.querySelectorAll('.c-images__thumbs__li'); }
  function slides() { return gallery.querySelectorAll('.c-images__holder .c-images__li'); }
  function colorRadios() { return colorFs.querySelectorAll('input[type="radio"]'); }

  /* Dok programski menjamo boju (smer slika → boja), app.js emituje image:update i pomerio bi
     galeriju na "svoju" sliku te varijante. Zaustavljamo taj jedan događaj da slika koju je kupac
     izabrao ostane na ekranu. Capture listener na window se izvršava pre bubble listenera iz app.js. */
  var syncing = false;
  window.addEventListener('image:update', function (e) {
    if (syncing) e.stopImmediatePropagation();
  }, true);

  function fireChange(el) {
    syncing = true;
    try {
      el.dispatchEvent(new Event('change', { bubbles: true }));
    } finally {
      syncing = false;
    }
  }

  function selectedOthers() {
    var sel = {};
    for (var i = 0; i < fieldsets.length; i++) {
      var idx = parseInt(fieldsets[i].getAttribute('data-option-index'), 10);
      if (idx === colorIdx) continue;
      var r = fieldsets[i].querySelector('input[type="radio"]:checked');
      if (r) sel[idx] = r.value;
    }
    return sel;
  }

  /* Varijanta te boje koja ima sliku: prvo ona koja se poklapa i sa izabranom veličinom,
     pa dostupna, pa bilo koja. */
  function variantForColor(color) {
    var cands = variants.filter(function (v) {
      return v.options && v.options[colorIdx] === color && v.featured_image;
    });
    if (!cands.length) return null;
    var sel = selectedOthers();
    var exact = cands.filter(function (v) {
      return Object.keys(sel).every(function (k) { return v.options[k] === sel[k]; });
    });
    var pool = exact.length ? exact : cands;
    for (var i = 0; i < pool.length; i++) if (pool[i].available) return pool[i];
    return pool[0];
  }

  function thumbIndexForVariant(id) {
    var t = thumbs();
    for (var i = 0; i < t.length; i++) {
      var ids = (t[i].getAttribute('data-id') || '').split(',');
      if (ids.indexOf(String(id)) > -1) return i;
    }
    return -1;
  }

  function showSlide(i) {
    var t = thumbs()[i];
    if (!t) return;
    var holder = gallery.querySelector('.c-images__holder');
    var thumbsEl = gallery.querySelector('.c-images__thumbs');
    var sw = holder && holder.swiper;
    if (sw && typeof sw.slideTo === 'function') {
      sw.slideTo(i);
      if (thumbsEl && thumbsEl.swiper) thumbsEl.swiper.slideTo(i);
    } else {
      var fig = t.querySelector('.c-images__thumbs__image');
      if (fig) fig.click();
    }
    var all = thumbs();
    for (var k = 0; k < all.length; k++) all[k].classList.remove('active');
    t.classList.add('active');
  }

  /* ---------- 1) boja → slika ---------- */
  colorFs.addEventListener('change', function (e) {
    if (syncing) return;
    var r = e.target;
    if (!r || r.type !== 'radio' || !r.checked) return;
    var v = variantForColor(r.value);
    if (!v) return;
    var i = thumbIndexForVariant(v.id);
    if (i >= 0) showSlide(i);
  });

  /* ---------- 2) slika → boja ---------- */
  function colorForSlide(i) {
    var t = thumbs()[i];
    if (!t) return null;
    var ids = (t.getAttribute('data-id') || '').split(',');
    for (var k = 0; k < ids.length; k++) {
      var v = byId[ids[k]];
      if (v && v.options) return v.options[colorIdx];
    }
    return null;
  }

  /* ---------- 3) + 4) nijedna boja ---------- */
  function clearColor() {
    var radios = colorRadios();
    if (radios.length < 2) return; /* jedna boja: ostaje označena */
    var was = null;
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) { was = radios[i]; radios[i].checked = false; }
    }
    if (!was) return;
    fireChange(was); /* app.js prazni ID varijante, cenu/zalihu vraća na početno */
  }

  function selectColor(color) {
    var radios = colorRadios();
    var radio = null;
    for (var i = 0; i < radios.length; i++) if (radios[i].value === color) { radio = radios[i]; break; }
    if (!radio) return;
    if (radio.disabled) { clearColor(); return; } /* boja skroz rasprodata → nijedna boja */
    if (radio.checked) return;
    radio.checked = true;
    fireChange(radio);
  }

  function applySlide(i) {
    var c = colorForSlide(i);
    if (c) selectColor(c); else clearColor();
  }

  function activeIndex() {
    var s = slides();
    for (var i = 0; i < s.length; i++) if (s[i].classList.contains('swiper-slide-active')) return i;
    return -1;
  }

  var lastIdx = -1;
  function onSlideChange() {
    var i = activeIndex();
    if (i < 0 || i === lastIdx) return;
    var first = lastIdx === -1;
    lastIdx = i;
    if (first) return; /* inicijalizacija galerije — ne diramo izbor pri učitavanju */
    applySlide(i);
  }

  var mo = new MutationObserver(onSlideChange);
  slides().forEach(function (li) { mo.observe(li, { attributes: true, attributeFilter: ['class'] }); });

  /* Klik na sličicu koja je već aktivna ne menja klasu, pa ga hvatamo direktno. */
  gallery.addEventListener('click', function (e) {
    var li = e.target.closest ? e.target.closest('.c-images__thumbs__li') : null;
    var idx = -1;
    if (li) {
      idx = Array.prototype.indexOf.call(thumbs(), li);
    } else if (e.target.closest && e.target.closest('.c-images__holder')) {
      idx = activeIndex();
    }
    if (idx < 0) return;
    applySlide(idx);
  });
})();
